<div
  class="chat-message"
  [ngClass]="{
    'chat-message--user': isUser,
    'chat-message--agent': isAgent,
    'chat-message--typing': isTyping && isAgent,
    'chat-message--has-charts': message.charts?.length
  }"
>
  <div class="chat-message__main" *ngIf="message.interrupt">
    <sgt-approval-card [interrupt]="message.interrupt" [readonly]="true"></sgt-approval-card>
  </div>

  <div class="chat-message__main" *ngIf="!message.interrupt">
    <div
      *ngFor="let reference of documentReferences; trackBy: trackByReferenceId"
      class="chat-message__document-ref"
    >
      <i
        [class]="reference.icon.className"
        [ngClass]="'chat-message__document-ref-icon--' + reference.icon.modifier"
        class="chat-message__document-ref-icon"
        aria-hidden="true"
      ></i>
      <span class="chat-message__document-ref-info">
        <span class="chat-message__document-ref-title">
          {{ reference.label }}
        </span>
        <span class="chat-message__document-ref-type">{{ reference.icon.label }}</span>
      </span>
    </div>

    <div
      *ngFor="let reference of informationReferences; trackBy: trackByReferenceId"
      class="chat-message__document-ref"
    >
      <i class="fas fa-chart-bar chat-message__document-ref-icon chat-message__document-ref-icon--information" aria-hidden="true"></i>
      <span class="chat-message__document-ref-info">
        <span class="chat-message__document-ref-title">{{ reference.title }}</span>
        <span class="chat-message__document-ref-meta" *ngIf="reference.generatedAt">
          Gerado em {{ reference.generatedAt | date: 'dd/MM/yyyy' }} às {{ reference.generatedAt | date: 'HH:mm' }}
        </span>
      </span>
    </div>

    <ng-container *ngIf="isUser">
      <div
        *ngFor="let att of message.attachments"
        class="chat-message__artifact"
      >
        <sgt-message-attachment
          [attachment]="att"
        ></sgt-message-attachment>
      </div>
    </ng-container>

    <div
      *ngIf="isUser && message.quickActionTitle"
      class="chat-message__quick-action"
    >
      <i class="fas fa-bolt chat-message__quick-action-icon"></i>
      <span class="chat-message__quick-action-title">{{
        message.quickActionTitle
      }}</span>
    </div>

    <div class="chat-message__bubble" *ngIf="hasBubbleContent">
      <div
        *ngIf="isAgent && message.htmlContent"
        class="chat-message__text markdown-content"
        [innerHTML]="message.htmlContent"
      ></div>

      <div
        *ngIf="isUser && message.content"
        class="chat-message__text chat-message__text--typed"
      >{{ message.content }}</div>
    </div>

    <ng-container *ngIf="isAgent">
      <div
        *ngFor="let att of message.attachments"
        class="chat-message__artifact"
      >
        <sgt-message-attachment [attachment]="att"></sgt-message-attachment>
      </div>
    </ng-container>

    <div
      *ngFor="let chart of message.charts"
      class="chat-message__bubble chat-message__bubble--chart chat-message__artifact"
    >
      <sgt-message-chart [chart]="chart"></sgt-message-chart>
    </div>

    <div class="chat-message__footer" *ngIf="isUser">
      <span class="chat-message__meta">{{ formattedTimestamp }}</span>
    </div>

    <div
      class="chat-message__footer"
      *ngIf="isAgent && (message.htmlContent || hasCharts || hasAttachments)"
    >
      <span class="chat-message__meta">{{ formattedTimestamp }}</span>

      <div class="chat-message__actions" *ngIf="message.htmlContent">
        <button
          type="button"
          class="chat-message__action-btn"
          (click)="onCopy()"
          [sgtTooltip]="copied ? 'Copiado!' : 'Copiar resposta'"
          tooltipPosition="bottom"
        >
          <i [class]="copied ? 'fas fa-check' : 'far fa-copy'"></i>
        </button>
      </div>
    </div>
  </div>
</div>
